import React from 'react';
import { Form, Field } from 'react-final-form';
import { composeValidators, getNumericChars } from '../../utils/helper';
import { isMobile, required, isName, email } from '../../utils/validation';
import '../OfferCampaign/CampaignForm.scss';

const onChangePhone = (event, input) => {
  const val = event.target.value;
  input.onChange(getNumericChars(val));
};

function LeadGenForm(props) {
  const {
    submitDetails,
    persistFormValue,
    dataLocale: { CONTINUE, NAME, PHONE_NUMBER, EMAIL_ID, CITY },
    formConfig = {},
    localeInfo,
    setCurrentPhoneCode,
    redisCommonData,
  } = props;
  const otherCountryCodes = redisCommonData.AVAILABLE_COUNTRY_CODE
    ? JSON.parse(redisCommonData.AVAILABLE_COUNTRY_CODE)
    : {};
  const { name, mobileNumber, email: userEmail, city, phone, location } = persistFormValue || {};
  const {
    emailMandatory,
    nameMandatory,
    phoneMandatory,
    showEmail,
    showName,
    showPhone,
    showCity,
  } = formConfig;
  const { phoneCode, countryCode } = localeInfo;
  const isDesktop = Boolean(process.env.CLIENT_TYPE === 'desktop');
  const getUserFormData = values => {
    submitDetails(values);
  };
  return (
    <div className={`${isDesktop ? 'container overflow-hidden' : ''}`}>
      <div className={`${isDesktop ? 'row' : ''}`}>
        <div className={`${isDesktop ? 'col-md-4 col-lg-3' : ''}`}></div>
        <div className={`${isDesktop ? 'col-md-4 col-lg-6' : ''}`}>
          <div className={`${isDesktop ? 'padding-t20' : ''}`}>
            <Form
              initialValues={{
                name,
                mobileNumber: phone || mobileNumber,
                email: userEmail,
                city: city || location,
                countryCode,
                phoneCode,
                country: countryCode,
              }}
              onSubmit={getUserFormData}
            >
              {({ handleSubmit, valid }) => {
                return (
                  <form className="campaign-form pd-t20 pd-b30 margin-t40" onSubmit={handleSubmit}>
                    <div>
                      {showName && (
                        <Field
                          name="name"
                          validate={nameMandatory ? composeValidators(required, isName) : isName}
                        >
                          {({ input, meta }) => {
                            return (
                              <div className="form-group pos-rel mr-b15">
                                <input
                                  {...input}
                                  autoComplete="off"
                                  className="form-input"
                                  maxLength="50"
                                  type="text"
                                />
                                <label className="fsp14">
                                  <span>{NAME}</span>
                                </label>
                                <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                                  {meta.error && meta.touched ? meta.error : ''}
                                </span>
                              </div>
                            );
                          }}
                        </Field>
                      )}
                      {showEmail && (
                        <Field
                          name="email"
                          validate={emailMandatory ? composeValidators(required, email) : email}
                        >
                          {({ input, meta }) => (
                            <div className="form-group pos-rel mr-b15 margin-t40">
                              <input
                                {...input}
                                autoComplete="off"
                                className="form-input"
                                type="text"
                              />
                              <label>
                                <span className="text-capitalize">
                                  {EMAIL_ID}
                                  {emailMandatory && <sup>*</sup>}
                                </span>
                              </label>
                              {meta.error && meta.touched && (
                                <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          )}
                        </Field>
                      )}
                      {showPhone && (
                        <Field
                          name="mobileNumber"
                          validate={
                            phoneMandatory ? composeValidators(required, isMobile) : isMobile
                          }
                        >
                          {({ input, meta }) => {
                            return (
                              <div className="mr-b15 display-flex form-group margin-t40">
                                <div className="country-code mr-r12 margin-r12">
                                  <select
                                    className="form-input inline-block text-center display-center"
                                    name="countryCodes"
                                    style={{ padding: 0 }}
                                    onChange={e => {
                                      setCurrentPhoneCode(e.target.value);
                                    }}
                                  >
                                    {otherCountryCodes?.otherCountryCode?.map(countryCode => (
                                      <option
                                        selected={countryCode === localeInfo?.phoneCode}
                                        value={countryCode}
                                      >
                                        {countryCode}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="flex-1">
                                  <div className="pos-rel">
                                    <input
                                      className="form-input"
                                      {...input}
                                      autoComplete="off"
                                      maxLength={localeInfo?.mobileNumberLength}
                                      type="tel"
                                      onChange={e => onChangePhone(e, input)}
                                    />
                                    <label className="text-capitalize">
                                      <span>
                                        {PHONE_NUMBER}
                                        {phoneMandatory && <sup>*</sup>}
                                      </span>
                                    </label>
                                  </div>
                                  <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                                    {meta.error && meta.touched ? meta.error : ''}
                                  </span>
                                </div>
                              </div>
                            );
                          }}
                        </Field>
                      )}
                      {showCity && (
                        <Field
                          name="city"
                          validate={nameMandatory ? composeValidators(required, isName) : isName}
                        >
                          {({ input, meta }) => {
                            return (
                              <div className="form-group pos-rel mr-b15 margin-t40">
                                <input
                                  {...input}
                                  autoComplete="off"
                                  className="form-input"
                                  maxLength="50"
                                  type="text"
                                />
                                <label className="fsp14">
                                  <span>{CITY}</span>
                                </label>
                                <span className="block margin-t4 fs12 mr-t4 fsp12 text-color_brick_red">
                                  {meta.error && meta.touched ? meta.error : ''}
                                </span>
                              </div>
                            );
                          }}
                        </Field>
                      )}
                      <div
                        className="btn-container-non-fixed "
                        style={{ marginBottom: '80px', marginTop: '50px' }}
                      >
                        <button
                          className="form-submit fsp18 fs18 fw500 text-uppercase bora-4"
                          disabled={!valid}
                          type="submit"
                        >
                          {CONTINUE}
                        </button>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeadGenForm;
